import { useMutation } from '@tanstack/react-query'

import { agreeToAgreementRequest } from '@src/api'
import { DefaultApiAgreeToAgreementRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useAgreeToAgreementRequest = () => {
  const { axiosInstance } = useAxios()
  return useMutation({
    mutationFn: (params: DefaultApiAgreeToAgreementRequestRequest) =>
      agreeToAgreementRequest(axiosInstance, params),
  })
}
